import { DataSource, Layout, Table, } from "@mcleod/components";

export abstract class AutogenLayoutEdiRefNumber extends Layout {
    sourceEdiRefNumber: DataSource;
    tableEdiRefNumber: Table;
}
